import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface UserStatusProps {
  onOpenProfile?: () => void;
}

const UserStatus: React.FC<UserStatusProps> = ({ onOpenProfile }) => {
  const navigate = useNavigate();
  const { profile, isGuest, isAdmin, loading, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  if (loading) return null;

  if (isGuest) {
    return (
      <button
        onClick={() => navigate('/auth')}
        className="font-pixel text-[10px] px-3 py-2 bg-secondary/60 text-foreground hover:bg-secondary/80 rounded-sm border border-border transition-colors"
      >
        👤 Guest <span className="text-primary">[Login]</span>
      </button>
    );
  }

  const displayName = profile?.username || '...';

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => navigate('/profile')}
        className="font-pixel text-[10px] px-3 py-2 bg-secondary/60 text-foreground hover:bg-secondary/80 rounded-sm border border-border transition-colors"
      >
        👤 {displayName}
      </button>
      <button
        onClick={() => setOpen(!open)}
        className="font-pixel text-[10px] px-1 py-2 bg-secondary/60 text-foreground hover:bg-secondary/80 rounded-sm border border-border transition-colors ml-0.5"
      >
        ▼
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 w-40 bg-card border-2 border-border rounded-sm shadow-lg z-50">
          {isAdmin && (
            <button
              onClick={() => { setOpen(false); navigate('/admin'); }}
              className="w-full text-left font-pixel text-[10px] px-3 py-2 text-foreground hover:bg-secondary/60 transition-colors"
            >
              ⚙ ADMIN PANEL
            </button>
          )}
          <div className="h-px bg-border" />
          <button
            onClick={async () => { setOpen(false); await signOut(); navigate('/'); }}
            className="w-full text-left font-pixel text-[10px] px-3 py-2 text-muted-foreground hover:text-foreground transition-colors"
          >
            LOGOUT
          </button>
        </div>
      )}
    </div>
  );
};

export default UserStatus;
